var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlan = function SvgPlan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 540 360"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 360,
    fill: "#FCF7F7",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A1A4B8",
    d: "M370.403 155.1a8.1 8.1 0 0 0-8.111.021l-157.248 91.673c-2.69 1.571-2.69 5.443.021 6.992l37.112 21.515-4.023 5.228 7.078-.28a45.1 45.1 0 0 0 20.869-6.088c27.324-15.878 103.162-59.94 106.023-61.575l39.888-22.934c3.98-2.281 3.98-8.003.022-10.305z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__a)",
    d: "m399.126 188.964-153.484 89.392a16.1 16.1 0 0 1-16.093.043l-91.221-53.076-5.852-3.421c-7.68-5.206-6.368-15.103-1.656-18.846.172-.151.301-.215.408-.28l154.28-83.842a16.2 16.2 0 0 1 16.114.043l59.918 29.195 38.145 21.192c5.572 2.926 7.724 14.006-.559 19.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E9FB",
    d: "m397.103 183.908-151.462 88.209a16.21 16.21 0 0 1-16.092.043l-95.567-55.314c-7.896-4.238-7.122-11.897-1.7-14.995l153.312-89.049c5.012-2.839 11.015-2.968 15.985-.064l97.546 56.023c5.379 3.12 5.422 11.252-2.022 15.147"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#343C6B",
    d: "M396.265 182.854 245.384 270.74c-4.905 2.818-10.951 2.84-15.856.043l-94.19-54.518c-7.788-4.173-7.035-11.725-1.678-14.78l152.709-88.704c4.927-2.797 10.865-2.926 15.77-.064l96.148 55.206c5.271 3.076 5.336 11.101-2.022 14.931"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__b)",
    d: "M396.265 182.854 245.384 270.74c-4.905 2.818-10.951 2.84-15.856.043l-94.19-54.518c-7.788-4.173-7.035-11.725-1.678-14.78l152.709-88.704c4.927-2.797 10.865-2.926 15.77-.064l96.148 55.206c5.271 3.076 5.336 11.101-2.022 14.931"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2157",
    d: "m348.328 144.902-14.006-8.089a3.44 3.44 0 0 0-3.378-.022 1.214 1.214 0 0 0 0 2.109l14.135 8.154a3.29 3.29 0 0 0 3.27 0c.818-.452.818-1.657-.021-2.152"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#819BEA",
    d: "m286.69 118.676-11.747 6.842-134.336 78.161 104.238 60.176 30.098-17.513 116.027-67.469z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__c)",
    d: "m286.69 118.676-11.747 6.842-134.336 78.161 104.238 60.176 30.098-17.513 116.027-67.469z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBCCDD",
    d: "M263.541 227.797c-35.65 0-63.575-14.888-63.575-33.906s27.925-33.907 63.575-33.907c35.649 0 63.553 14.888 63.553 33.907s-27.904 33.906-63.553 33.906m0-66.888c-35.133 0-62.629 14.479-62.629 32.982 0 18.502 27.517 32.981 62.629 32.981s62.628-14.479 62.628-32.981c0-18.481-27.517-32.982-62.628-32.982"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBCCDD",
    d: "M263.543 222.526c31.773 0 57.53-12.82 57.53-28.635s-25.757-28.636-57.53-28.636-57.529 12.82-57.529 28.636 25.756 28.635 57.529 28.635"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M264.834 130.272c-.839 2.431-2.969 3.894-4.755 3.292-1.785-.624-2.56-3.077-1.721-5.508s3.916-6.884 5.723-6.282c1.764.624 1.592 6.067.753 8.498"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#12154C",
    d: "M259.713 123.969c-.387 2.625 4.97 4.303 6.024 2.345 0 0 7.423-16.523 9.209-20.331.021-.022.086-.043.086-.086 2.28-4.024 5.744-16.868 5.744-16.868l-10.693-4.26z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#464878",
    d: "M298.848 197.483c-.775-2.539-2.754-4.152-4.411-3.658-1.656.517-1.872 2.84-1.592 5.508.043.495.344.925.56 1.313.473.839.688 1.807.688 2.775 0 .753.108 1.549.344 2.345.538 1.721 2.259 2.861 3.529 3.485a2.11 2.11 0 0 0 2.839-1.011c.71-1.484 1.055-3.743.065-5.551-.409-.71-1.872-4.733-2.022-5.206m-19.772-1.399c-.409.302-.99.99-1.399 1.42-.989 1.033-2.345 1.635-3.743 2.13-1.915.667-3.486.818-4.583.538-1.075-.28-1.527-1.549-.903-2.453.602-.882 1.742-2.065 3.27-3.377.86-.753 1.678-1.463 2.323-2.001a4.58 4.58 0 0 0 1.614-3.098c.065-.667.151-1.248.237-1.291 2.345-.882 5.701-.409 6.303.731 0 0 .667 3.486.667 4.346 0 .56-.172 1.463-1.183 1.851-.645.258-1.657.537-2.603 1.204"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDF1",
    d: "M300.267 133.22c.022 22.203.065 46.299-1.162 62.886-.129 1.808-6.368 2.453-6.647.302-3.507-26.614-5.25-57.1-5.25-57.1a2.47 2.47 0 0 0-1.291-1.936l-.495-.258c-1.355-.71-1.57.215-1.57 1.743l.516 17.254s.108 23.3-1.786 33.455c-.301 1.635-7.142 1.635-7.314-.258-1.851-18.589-2.066-60.197-2.066-60.197l.237-8.821c0-.323 1.979-.409 4.884-.366 3.485.064 8.283.323 12.456.581 4.97.322 9.058.624 9.058.624.28 3.27.409 5.593.43 12.091"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#323858",
    d: "M275.462 124.807c-.688.517-1.377.882-2.194 1.097l.15-8.799c0-.323 1.979-.409 4.884-.366.409 3.27-.538 6.326-2.84 8.068"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBCCDD",
    d: "m286.175 137.523-2.56-1.334c-.667-.344-1.441.15-1.162 1.829l1.894 21.794z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#464878",
    d: "M300.419 119.622c.258 1.829.452 3.572.344 3.916-1.915 5.938-24.613 5.099-28.141.775l.646-10.327a35.7 35.7 0 0 0-.409-8.95l-3.141-17.535c-.538-5.68 4.087-10.068 8.24-10.025.903 0 1.828.15 2.71.43.345.086 2.733-1.528 3.077-1.398l3.249 1.506 3.808 1.742c.086.065.193.108.301.15.366.173.753.345 1.097.517 4.626 2.26 9.144 4.948 9.639 10.155a45.5 45.5 0 0 0-2.862 15.878c0 1.914.129 3.808.366 5.722l.108.926.215 1.828c.021-.021.43 2.41.753 4.69"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#12154C",
    d: "M300.417 119.622c-1.808.517-3.765 1.011-5.917 1.377a55.4 55.4 0 0 1-14.178.71l12.436-7.638h-6.476c3.205-6.561 3.507-7.314 3.507-7.314 1.14-2.647 2.366-6.648 2.495-12.22l3.163 17.878 2.517-1.549 1.528 2.216.215 1.829c-.022 0 .387 2.431.71 4.711"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M291.124 79.907a1.3 1.3 0 0 1-.301-.15l-2.582-1.184-1.033-10.843-7.401.71.99 10.391s-.452.194-.646.301c-1.398.732-2.237 1.7-2.28 2.604-.043.882.688 1.527 1.312 1.914 1.42.904 3.658 1.313 5.96 1.098 1.506-.151 2.926-.538 4.066-1.14 1.398-.732 2.259-1.7 2.281-2.604 0-.43-.151-.796-.366-1.097"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2BBBF",
    d: "m279.937 69.86.796 8.52c.086.881 1.936 1.268 3.356.537 2.173-1.14 3.851-3.077 3.679-4.991l-.452-4.777-7.379.71z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M275.44 73c1.721 5.939 5.787 6.175 9.401 4.046 2.432-1.442 4.454-3.486 4.798-6.197.215-1.764 1.377-3.506 1.356-4.948-.065-5.53-3.83-8.842-8.413-8.778-10.456.13-7.745 13.813-7.142 15.878z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#12154C",
    d: "M292.479 60.91c-.86-4.669-6.798-8.563-13.317-6.196-3.443 1.247-6.476 2.065-6.756 4.733-.365 3.506 2.41 5.27 2.41 5.27l.064-.451c.108-.818.839-1.356 1.657-1.356 1.721 0 4.131-.365 6.046.323.903.323 1.893.065 2.624-.56l1.42-1.247-1.42 2a1.85 1.85 0 0 0-.129 1.937c.065.13.108.28.172.409.151.387.302.796.388 1.29a1.373 1.373 0 0 0 1.914 1.034c.495-.216.969-.495 1.162-.818.495-.796 1.42-1.011 1.571-.473.387 1.398.452 2.151.365 2.56.603-.538 1.291-1.399 1.722-2.754.387-1.355.559-3.206.107-5.701"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M287.359 67.751c-.818 1.42-.732 2.99.193 3.507.925.538 2.324-.193 3.12-1.592.818-1.42.731-2.99-.194-3.507-.903-.538-2.302.194-3.119 1.592"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#6A7097",
    d: "M274.666 102.454c-1.98-.817-4.26.151-5.056 2.151l-35.564 88.984a5.35 5.35 0 0 0 .345 4.626l-.495 1.226c-.495 1.226-.172 2.582.688 3.485l-1.248 3.098a1.33 1.33 0 0 0 .28 1.399c.129.129.28.215.452.279a1.293 1.293 0 0 0 1.678-.731l1.205-3.012c1.334 0 2.603-.775 3.119-2.108l.474-1.184c1.527-.452 2.861-1.57 3.485-3.162l35.585-88.876a3.843 3.843 0 0 0-2.13-5.013z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D4D7",
    d: "M265.994 121.947c.495.473 4.217 2 5.357 2.022 2.366.043 4.539-.947 5.099-1.14 1.613-.56 4.324-1.399 7.229-2.367l-1.614-5.314c-1.829 1.033-3.744 1.979-5.615 2.517-.452.151-.775.258-1.033.28-2.41.236-6.648-3.442-7.272-1.097 0 0-4.884 2.345-2.151 5.099"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#464878",
    d: "M276.536 117.622c1.313.473 2.195 3.894 1.377 4.991 0 0 16.76-3.012 21.02-7.896 2.065-2.366 3.334-15.727 2.904-24.16 0 0-1.893-3.593-4.453-3.593a4.44 4.44 0 0 0-4.411 4.023c-.473 5.12-.495 16.459-1.14 18.395-.409 1.269-15.297 8.24-15.297 8.24"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M155.022 146.479c-.588 0-1.148-.118-1.579-.373l-35.505-20.494c-.461-.265-.707-.648-.707-1.07 0-.49.344-.971.952-1.314l35.024-20.22c1.07-.618 2.649-.677 3.581-.137l35.505 20.494c.461.265.706.648.706 1.069 0 .491-.343.972-.951 1.315l-35.024 20.22c-.579.343-1.305.51-2.002.51m-1.305-.844c.756.442 2.149.373 3.032-.137l35.024-20.22c.422-.245.677-.559.677-.844s-.235-.48-.432-.588l-35.505-20.495c-.755-.441-2.148-.373-3.031.138l-35.024 20.219c-.422.246-.677.56-.677.844 0 .285.235.481.432.589z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__d)",
    d: "M193 113.014v4.389l-38 21.943-38-21.943v-4.389z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__e)",
    d: "M193 113.014v4.389l-38 21.943-38-21.943v-4.389z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__f)",
    d: "m155 134.952-38-21.938 38-21.938 38 21.938z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m155 134.439-37.553-21.684-.447.259 38 21.938 38-21.938-.447-.254z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m155.002 129.894-29.226-16.876 29.226-16.87 29.226 16.87z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__g)",
    d: "m155 129.894-29.226-16.875L155 96.147l29.226 16.872z",
    opacity: 0.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__h)",
    d: "m155 91.89 29.226 16.875v4.254L155 96.143z",
    opacity: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__i)",
    d: "m155 96.143-29.226 16.876v-4.254L155 91.89z",
    opacity: 0.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__j)",
    d: "m155 125.637-29.226-16.872L155 91.89l29.226 16.875z",
    opacity: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m155 115.507-11.677-6.741L155 102.024l11.677 6.742z",
    opacity: 0.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m155 102.64 11.141 6.436.536-.31L155 102.024l-11.677 6.742.537.31z",
    opacity: 0.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__k)",
    d: "M155 125.637v4.258l29.226-16.876v-4.253z",
    opacity: 0.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__l)",
    d: "M125.774 108.766v4.253L155 129.895v-4.258z",
    opacity: 0.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "m155.002 125.175-28.826-16.645-.4.235 29.226 16.871 29.226-16.871-.4-.235z",
    opacity: 0.8
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__m)",
    d: "M155.107 86.159v-19.68l-16.319-10.15zm-17.672-32.86 17.672 10.991V21z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__n)",
    d: "M155.107 86.159v-19.68l-16.319-10.15zm-17.672-32.86 17.672 10.991V21z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__o)",
    d: "m155.107 86.159 16.323-29.83-16.323 10.15zm0-65.159v43.29l17.677-10.99z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__p)",
    d: "m155.107 86.159 16.323-29.83-16.323 10.15zm0-65.159v43.29l17.677-10.99z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M89.022 307.479c-.589 0-1.148-.118-1.58-.373l-35.504-20.494c-.461-.265-.707-.648-.707-1.07 0-.49.344-.971.952-1.314l35.024-20.22c1.07-.618 2.65-.677 3.581-.137l35.505 20.494c.461.265.706.648.706 1.069 0 .491-.343.972-.951 1.315l-35.024 20.22c-.58.343-1.305.51-2.002.51m-1.305-.844c.756.442 2.149.373 3.032-.137l35.024-20.22c.422-.245.677-.559.677-.844s-.235-.48-.432-.588l-35.505-20.495c-.755-.441-2.148-.373-3.031.138l-35.024 20.219c-.422.246-.677.56-.677.844 0 .285.235.481.431.589z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__q)",
    d: "M127 274.014v4.389l-38 21.943-38-21.943v-4.389z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__r)",
    d: "M127 274.014v4.389l-38 21.943-38-21.943v-4.389z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__s)",
    d: "m89 295.952-38-21.938 38-21.938 38 21.938z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m89 295.439-37.553-21.684-.447.259 38 21.938 38-21.938-.447-.254z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m89.002 290.894-29.226-16.876 29.226-16.871 29.226 16.871z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__t)",
    d: "m89 290.894-29.226-16.875L89 257.147l29.226 16.872z",
    opacity: 0.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__u)",
    d: "m89 252.89 29.226 16.875v4.254L89 257.143z",
    opacity: 0.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__v)",
    d: "m89 257.143-29.226 16.876v-4.254L89 252.89z",
    opacity: 0.5
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__w)",
    d: "m89 286.637-29.226-16.872L89 252.89l29.226 16.875z",
    opacity: 0.5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m89 276.507-11.677-6.741L89 263.024l11.677 6.742z",
    opacity: 0.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m89 263.64 11.141 6.436.536-.31L89 263.024l-11.677 6.742.537.31z",
    opacity: 0.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__x)",
    d: "M89 286.637v4.258l29.226-16.876v-4.253z",
    opacity: 0.5
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__y)",
    d: "M59.774 269.766v4.253L89 290.895v-4.258z",
    opacity: 0.5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "M89.002 286.175 60.176 269.53l-.4.235 29.226 16.871 29.226-16.871-.4-.235z",
    opacity: 0.8
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__z)",
    d: "M89.107 247.159V227.48l-16.319-10.151zm-17.672-32.86 17.672 10.991V182z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__A)",
    d: "M89.107 247.159V227.48l-16.319-10.151zm-17.672-32.86 17.672 10.991V182z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__B)",
    d: "m89.107 247.159 16.323-29.83-16.323 10.151zm0-65.159v43.29l17.677-10.991z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__C)",
    d: "m89.107 247.159 16.323-29.83-16.323 10.151zm0-65.159v43.29l17.677-10.991z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M428.022 146.479c-.588 0-1.148-.118-1.579-.373l-35.505-20.494c-.461-.265-.707-.648-.707-1.07 0-.49.344-.971.952-1.314l35.024-20.22c1.07-.618 2.649-.677 3.581-.137l35.505 20.494c.461.265.706.648.706 1.069 0 .491-.343.972-.951 1.315l-35.024 20.22c-.579.343-1.305.51-2.002.51m-1.305-.844c.756.442 2.149.373 3.032-.137l35.024-20.22c.422-.245.677-.559.677-.844s-.235-.48-.432-.588l-35.505-20.495c-.755-.441-2.148-.373-3.031.138l-35.024 20.219c-.422.246-.677.56-.677.844 0 .285.235.481.432.589z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__D)",
    d: "M466 113.014v4.389l-38 21.943-38-21.943v-4.389z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__E)",
    d: "M466 113.014v4.389l-38 21.943-38-21.943v-4.389z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__F)",
    d: "m428 134.952-38-21.938 38-21.938 38 21.938z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m428 134.439-37.553-21.684-.447.259 38 21.938 38-21.938-.447-.254z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m428.002 129.894-29.226-16.876 29.226-16.87 29.226 16.87z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__G)",
    d: "m428 129.894-29.226-16.875L428 96.147l29.226 16.872z",
    opacity: 0.5
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__H)",
    d: "m428 91.89 29.226 16.875v4.254L428 96.143z",
    opacity: 0.5
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__I)",
    d: "m428 96.143-29.226 16.876v-4.254L428 91.89z",
    opacity: 0.5
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__J)",
    d: "m428 125.637-29.226-16.872L428 91.89l29.226 16.875z",
    opacity: 0.5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m428 115.507-11.677-6.741L428 102.024l11.677 6.742z",
    opacity: 0.5
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m428 102.64 11.141 6.436.536-.31L428 102.024l-11.677 6.742.537.31z",
    opacity: 0.5
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__K)",
    d: "M428 125.637v4.258l29.226-16.876v-4.253z",
    opacity: 0.5
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__L)",
    d: "M398.774 108.766v4.253L428 129.895v-4.258z",
    opacity: 0.5
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "m428.002 125.175-28.826-16.645-.4.235 29.226 16.871 29.226-16.871-.4-.235z",
    opacity: 0.8
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__M)",
    d: "M428.107 86.159v-19.68l-16.319-10.15zm-17.672-32.86 17.672 10.991V21z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__N)",
    d: "M428.107 86.159v-19.68l-16.319-10.15zm-17.672-32.86 17.672 10.991V21z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__O)",
    d: "m428.107 86.159 16.323-29.83-16.323 10.15zm0-65.159v43.29l17.677-10.99z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__P)",
    d: "m428.107 86.159 16.323-29.83-16.323 10.15zm0-65.159v43.29l17.677-10.99z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M372.022 316.479c-.588 0-1.148-.118-1.579-.373l-35.505-20.494c-.461-.265-.707-.648-.707-1.07 0-.49.344-.971.952-1.314l35.024-20.22c1.07-.618 2.649-.677 3.581-.137l35.505 20.494c.461.265.706.648.706 1.069 0 .491-.343.972-.951 1.315l-35.024 20.22c-.579.343-1.305.51-2.002.51m-1.305-.844c.756.442 2.149.373 3.032-.137l35.024-20.22c.422-.245.677-.559.677-.844s-.235-.48-.432-.588l-35.505-20.495c-.755-.441-2.148-.373-3.031.138l-35.024 20.219c-.422.246-.677.56-.677.844 0 .285.235.481.432.589z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__Q)",
    d: "M410 283.014v4.389l-38 21.943-38-21.943v-4.389z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__R)",
    d: "M410 283.014v4.389l-38 21.943-38-21.943v-4.389z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__S)",
    d: "m372 304.952-38-21.938 38-21.938 38 21.938z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m372 304.439-37.553-21.684-.447.259 38 21.938 38-21.938-.447-.254z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m372.002 299.894-29.226-16.876 29.226-16.871 29.226 16.871z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__T)",
    d: "m372 299.894-29.226-16.875L372 266.147l29.226 16.872z",
    opacity: 0.5
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__U)",
    d: "m372 261.89 29.226 16.875v4.254L372 266.143z",
    opacity: 0.5
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__V)",
    d: "m372 266.143-29.226 16.876v-4.254L372 261.89z",
    opacity: 0.5
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__W)",
    d: "m372 295.637-29.226-16.872L372 261.89l29.226 16.875z",
    opacity: 0.5
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m372 285.507-11.677-6.741L372 272.024l11.677 6.742z",
    opacity: 0.5
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m372 272.64 11.141 6.436.536-.31L372 272.024l-11.677 6.742.537.31z",
    opacity: 0.5
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__X)",
    d: "M372 295.637v4.258l29.226-16.876v-4.253z",
    opacity: 0.5
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__Y)",
    d: "M342.774 278.766v4.253L372 299.895v-4.258z",
    opacity: 0.5
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "m372.002 295.175-28.826-16.645-.4.235 29.226 16.871 29.226-16.871-.4-.235z",
    opacity: 0.8
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__Z)",
    d: "M372.107 256.159V236.48l-16.319-10.151zm-17.672-32.86 17.672 10.991V191z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__aa)",
    d: "M372.107 256.159V236.48l-16.319-10.151zm-17.672-32.86 17.672 10.991V191z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__ab)",
    d: "m372.107 256.159 16.323-29.83-16.323 10.151zm0-65.159v43.29l17.677-10.991z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#plan_svg__ac)",
    d: "m372.107 256.159 16.323-29.83-16.323 10.151zm0-65.159v43.29l17.677-10.991z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__a",
    x1: 392,
    x2: 251.5,
    y1: 131.5,
    y2: 287.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3F7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__b",
    x1: 265.802,
    x2: 265.802,
    y1: 110.626,
    y2: 272.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__c",
    x1: 140.6,
    x2: 390.976,
    y1: 191.256,
    y2: 191.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__d",
    x1: 98.213,
    x2: 195.599,
    y1: 126.179,
    y2: 126.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__e",
    x1: 117.793,
    x2: 124.733,
    y1: 132.475,
    y2: 103.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__f",
    x1: 155,
    x2: 155,
    y1: 91.076,
    y2: 134.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__g",
    x1: 125.773,
    x2: 184.227,
    y1: 113.019,
    y2: 113.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__h",
    x1: 154.999,
    x2: 184.226,
    y1: 102.453,
    y2: 102.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__i",
    x1: 125.774,
    x2: 155.001,
    y1: 102.453,
    y2: 102.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__j",
    x1: 125.773,
    x2: 184.227,
    y1: 108.761,
    y2: 108.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__k",
    x1: 154.999,
    x2: 184.226,
    y1: 119.329,
    y2: 119.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__l",
    x1: 125.774,
    x2: 155.001,
    y1: 119.329,
    y2: 119.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__m",
    x1: 145.222,
    x2: 153.159,
    y1: 30.757,
    y2: 79.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F70D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#402F9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__n",
    x1: 148.025,
    x2: 168.11,
    y1: 71.984,
    y2: 51.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686C8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ACC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__o",
    x1: 158.099,
    x2: 164.416,
    y1: 87.891,
    y2: 33.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7760BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C17FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__p",
    x1: 171.431,
    x2: 129.667,
    y1: 86.456,
    y2: 49.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__q",
    x1: 32.213,
    x2: 129.599,
    y1: 287.179,
    y2: 287.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__r",
    x1: 51.793,
    x2: 58.733,
    y1: 293.475,
    y2: 264.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__s",
    x1: 89,
    x2: 89,
    y1: 252.076,
    y2: 295.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__t",
    x1: 59.773,
    x2: 118.227,
    y1: 274.019,
    y2: 274.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__u",
    x1: 88.999,
    x2: 118.226,
    y1: 263.453,
    y2: 263.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__v",
    x1: 59.774,
    x2: 89.001,
    y1: 263.453,
    y2: 263.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__w",
    x1: 59.773,
    x2: 118.227,
    y1: 269.761,
    y2: 269.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__x",
    x1: 88.999,
    x2: 118.226,
    y1: 280.329,
    y2: 280.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__y",
    x1: 59.774,
    x2: 89.001,
    y1: 280.329,
    y2: 280.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__z",
    x1: 79.222,
    x2: 87.159,
    y1: 191.757,
    y2: 240.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F70D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#402F9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__A",
    x1: 82.025,
    x2: 102.11,
    y1: 232.984,
    y2: 212.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686C8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ACC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__B",
    x1: 92.099,
    x2: 98.416,
    y1: 248.891,
    y2: 194.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7760BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C17FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__C",
    x1: 105.431,
    x2: 63.667,
    y1: 247.456,
    y2: 210.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__D",
    x1: 371.213,
    x2: 468.599,
    y1: 126.179,
    y2: 126.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__E",
    x1: 390.793,
    x2: 397.733,
    y1: 132.475,
    y2: 103.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__F",
    x1: 428,
    x2: 428,
    y1: 91.076,
    y2: 134.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__G",
    x1: 398.773,
    x2: 457.227,
    y1: 113.019,
    y2: 113.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__H",
    x1: 427.999,
    x2: 457.226,
    y1: 102.453,
    y2: 102.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__I",
    x1: 398.774,
    x2: 428.001,
    y1: 102.453,
    y2: 102.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__J",
    x1: 398.773,
    x2: 457.227,
    y1: 108.761,
    y2: 108.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__K",
    x1: 427.999,
    x2: 457.226,
    y1: 119.329,
    y2: 119.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__L",
    x1: 398.774,
    x2: 428.001,
    y1: 119.329,
    y2: 119.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__M",
    x1: 418.222,
    x2: 426.159,
    y1: 30.757,
    y2: 79.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F70D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#402F9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__N",
    x1: 421.025,
    x2: 441.11,
    y1: 71.984,
    y2: 51.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686C8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ACC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__O",
    x1: 431.099,
    x2: 437.416,
    y1: 87.891,
    y2: 33.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7760BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C17FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__P",
    x1: 444.431,
    x2: 402.667,
    y1: 86.456,
    y2: 49.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__Q",
    x1: 315.213,
    x2: 412.599,
    y1: 296.179,
    y2: 296.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__R",
    x1: 334.793,
    x2: 341.733,
    y1: 302.475,
    y2: 273.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__S",
    x1: 372,
    x2: 372,
    y1: 261.076,
    y2: 304.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__T",
    x1: 342.773,
    x2: 401.227,
    y1: 283.019,
    y2: 283.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__U",
    x1: 371.999,
    x2: 401.226,
    y1: 272.453,
    y2: 272.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__V",
    x1: 342.774,
    x2: 372.001,
    y1: 272.453,
    y2: 272.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__W",
    x1: 342.773,
    x2: 401.227,
    y1: 278.761,
    y2: 278.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__X",
    x1: 371.999,
    x2: 401.226,
    y1: 289.329,
    y2: 289.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__Y",
    x1: 342.774,
    x2: 372.001,
    y1: 289.329,
    y2: 289.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__Z",
    x1: 362.222,
    x2: 370.159,
    y1: 200.757,
    y2: 249.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F70D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#402F9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__aa",
    x1: 365.025,
    x2: 385.11,
    y1: 241.984,
    y2: 221.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686C8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ACC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__ab",
    x1: 375.099,
    x2: 381.416,
    y1: 257.891,
    y2: 203.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7760BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C17FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plan_svg__ac",
    x1: 388.431,
    x2: 346.667,
    y1: 256.456,
    y2: 219.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACCD7"
  })))));
};
export default SvgPlan;